import axios from 'src/utils/axios';
import { URLS } from 'src/utils/url';
import { DownloadFile } from "src/utils/file";

const BPARTNER_KEY = 'bpartnerId';
class BpartnerService {

	constructor() {}

	load(id) {
		return axios.get(`${URLS.BPARTNERS}/${id}`);
	}

	search(_params) {
		return axios.get(URLS.BPARTNERS, { params: _params });
	}

	setBpartner(id) {
		localStorage.setItem(BPARTNER_KEY, id);
	}

	getBpartner() {
		return localStorage.getItem(BPARTNER_KEY);
	}

	clearStorage() {
		localStorage.removeItem(BPARTNER_KEY);
		delete axios.defaults.headers.common['X-EP-BPartner'];
	}

	setInterceptor() {
		axios.defaults.headers.common['X-EP-BPartner'] = this.getBpartner();
	}

	searchRepaymentPlans (_params) {
		//return	axios.get(`${URLS.BPARTNERS}/${id}/repaymentPlans`, { params: _params });
		return axios.get(URLS.BPARTNERS + "/repaymentPlans", { params: _params });
	}

	syncRepaymentPlans(customerId) {
		return axios.get(URLS.BPARTNERS_REPAYMENT_PLAN_SYNC, { params: { customerId } });
	}

	downloadPdfRepaymentPlan(id, type) {
		let url = `${URLS.BPARTNERS}/repaymentPlan/${id}/download`;
		//let url = `${URLS.BPARTNERS}/repaymentPlan/${id}/download/${type}`;
		/*if (appMobileService.isMobile()) {
			let baseUrl = '';

			let string = getBaseUrl();
			//console.log("string", string);
			let lastCharacter = string.substr(string.length - 1);

			if(lastCharacter === "/") 
				baseUrl = string.slice(0,-1);
			else 
				baseUrl = string;
			console.log("baseUrl", baseUrl);
			
			url = `${baseUrl}${url}`;

			appMobileService.downloadDocument(url);
			return new Promise((resolve, reject) => resolve());
		}*/
		
		return DownloadFile(url , {})
	}


}

const bpartnerService = new BpartnerService();

export default bpartnerService;
